import React from "react";
import { Link } from "react-router-dom";
import { CSS } from "src/_utils/styles";
import { useEBSSSLayout } from "src/base/context/EBSSSLayoutContext/useEBSSSLayout";
import Page from "src/base/Page";

const NotFound = () => {
  const { trans } = useEBSSSLayout();
  return (
    <div className="d-flex m-auto w-100 h-100 flex-column justify-items-center text-center align-items-center mt-5">
      <p className="fw-bold" style={CSS({ fontSize: 50, color: "black" })}>
        404
      </p>
      <h1>{trans("website.not-found")}</h1>
      <h3>{trans("website.this-resource-may-have-been-deleted-or-does-not-exist")}</h3>
      <Link to="/v2" className="btn btn-primary mt-3">
        {trans("website.back-to-home")}
      </Link>
    </div>
  );
};

export default NotFound;
